import { RoverBrand } from '@rover/types/src/RoverBrand';
import getRoverBrand from '@rover/utilities/getRoverBrand';

import roverLoader from './rover-loader-animation.svg?url';
import catInAFlatLoader from './rover-loader-animation-ciaf.svg?url';

const loaderImageMap: Record<string, string> = {
  [RoverBrand.Rover]: roverLoader,
  [RoverBrand.CatInAFlat]: catInAFlatLoader,
};

const getLoaderImage = (): string => {
  const brand = getRoverBrand();
  return loaderImageMap[brand] ?? roverLoader;
};

export default getLoaderImage;
